import { Modal, Skeleton } from 'antd';
import React, { useContext } from 'react';

import { IntegrationsContext } from '@app/providers';

import type { InstagramIntegrationFrameModalProps } from '@pages/Integrations/IntegrationsList/types';

export const OAuthIntegrationFrameModal: React.FC<
  InstagramIntegrationFrameModalProps
> = ({ currentAuthLink }) => {
  const { isOAuthFrameOpen, setIsOAuthFrameOpen } =
    useContext(IntegrationsContext);

  const handleCancel = () => {
    setIsOAuthFrameOpen(false);
  };

  return (
    <Modal
      open={isOAuthFrameOpen}
      onCancel={handleCancel}
      title={'Авторизация'}
      footer={''}
      className="oauth-settings-modal"
    >
      {currentAuthLink ? (
        <iframe src={currentAuthLink} className="oauth-settings-frame" />
      ) : (
        <Skeleton active />
      )}
    </Modal>
  );
};
